import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ICKLeverantorDetail } from "../../models/ckLeverantorDetail";
import { ICKLeverantorList } from "../../models/ckLeverantorList";
import { CKLeverantorViewModel } from "../../models/ckLeverantorListViewModel";
import { CKLeverantorService } from "../../services/ckleverantor.service";
import { CkleverantorDetailsDialogComponent } from "../ckleverantor-details-dialog/ckleverantor-details-dialog.component";

@Component({
    selector: "rask-ckleverantor-list",
    templateUrl: "./ckleverantor-list.component.html",
    styleUrls: ["./ckleverantor-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        TranslatePipe
    ]
})
export class CkleverantorListComponent {
    ckleverantorer: CKLeverantorViewModel[] = [];

    private readonly busyService = inject(BusyService);
    private readonly ckLeverantorService = inject(CKLeverantorService);
    private readonly ngbModalService = inject(NgbModal);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("ckleverantorer") set list(val: any) {
        if (!val) {
            return;
        }
        this.ckleverantorer = val.ckLeverantorer.map((x: ICKLeverantorList) => new CKLeverantorViewModel(x));
    }

    showDetails(event: Event, ckLeverantor: CKLeverantorViewModel): void {
        event.preventDefault();
        if (!ckLeverantor || !ckLeverantor.id) {
            return;
        }

        this.busyService.addWork(this.ckLeverantorService.getCkLeverantorById(ckLeverantor.id))
            .subscribe(result => {
                if (result) {
                    const modalRef = this.ngbModalService.open(CkleverantorDetailsDialogComponent, {
                        keyboard: false,
                        backdrop: "static",
                        size: "lg"
                    });
                    const model = modalRef.componentInstance as CkleverantorDetailsDialogComponent;
                    model.data = result;
                    modalRef.result.finally( () => {
                        // Superbad. Återigen ett tecken på att man behöver en snyggare hanteringar av modal som har stöd för många olika scenarion.
                        // Bland annat att på något vis vänta in sparat resultat.
                        setTimeout(() => {
                            // eslint-disable-next-line sonarjs/no-nested-functions
                            this.ckLeverantorService.getCkLeverantorById(ckLeverantor.id).subscribe(updatedCkLeverantor => {
                                const kindex = this.ckleverantorer.indexOf(ckLeverantor);
                                const ckLeverantorArrCopy = [...this.ckleverantorer];
                                ckLeverantorArrCopy.splice(kindex, 1, new CKLeverantorViewModel(this.getCkLeverantorListFromDetail(updatedCkLeverantor)));
                                this.ckleverantorer = ckLeverantorArrCopy;
                            });
                        }, 200);
                    });
                }
            });
    }

    private getCkLeverantorListFromDetail(updatedCkLeverantor: ICKLeverantorDetail): ICKLeverantorList {
        return {
            aktiv: updatedCkLeverantor.aktivLime,
            avdelning: updatedCkLeverantor.avdelning,
            beskrivning: updatedCkLeverantor.beskrivning,
            besokPostortadress: updatedCkLeverantor.besokPostortadress,
            huvudkod: updatedCkLeverantor.huvudkod,
            id: updatedCkLeverantor.id,
            internnummer: updatedCkLeverantor.internnummer,
            namn: updatedCkLeverantor.namn,
            orgNummer: updatedCkLeverantor.orgNummer,
            befraktare: updatedCkLeverantor.befraktare,
            doljForKundorder: updatedCkLeverantor.doljForLeverantorsorder
        } as ICKLeverantorList;
    }
}
